import React from 'react';
import { motion } from 'framer-motion';
import { PERIOD_OPTIONS } from '../constants';
import type { TimePeriod } from '../types';

interface PeriodSelectorProps {
    value: TimePeriod;
    onChange: (period: TimePeriod) => void;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({ value, onChange }) => {
    return (
        <div className="flex items-center gap-1.5 px-[18px] pb-4 flex-wrap">
            {PERIOD_OPTIONS.map(option => {
                const isActive = value === option.value;
                const isCustom = option.value === 'custom';
                
                return (
                    <motion.button
                        key={option.value}
                        onClick={() => onChange(option.value)}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className={`
                            px-3 py-1.5 rounded-lg text-[12px] font-medium transition-all
                            ${isActive 
                                ? 'bg-[var(--brand)] text-white shadow-sm' 
                                : 'bg-[var(--bg-elevated)] border border-[var(--border)] text-[var(--text-secondary)] hover:border-[var(--border-strong)] hover:text-[var(--text)]'
                            }
                            ${isCustom ? 'flex items-center gap-1' : ''}
                        `}
                    >
                        {option.label}
                        {isCustom && (
                            <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                <line x1="16" y1="2" x2="16" y2="6"/>
                                <line x1="8" y1="2" x2="8" y2="6"/>
                                <line x1="3" y1="10" x2="21" y2="10"/>
                            </svg>
                        )}
                    </motion.button>
                );
            })}
        </div>
    );
};